import { PaymentMethod } from '@repo/common';

export const mapPaymentMethodEnumToString = (paymentMethod: string) => {
    switch (paymentMethod) {
        case PaymentMethod.BANK:
            return 'Bank';

        case PaymentMethod.CASH:
            return 'Cash';

        case PaymentMethod.MobileBankingBkash:
            return 'Bkash';
        case PaymentMethod.MobileBankingRocket:
            return 'Rocket';
        case PaymentMethod.MobileBankingNagad:
            return 'Nagad';
    }

    return 'Cash';
};
